import React, {useState, useEffect} from 'react';
import styles from './BindBrands.module.css';
import Button from '../../Button/Button';
import {getAllMaterialTypesUrl} from '../../../helpers/constants';
import useApi from '../../../hooks/useApi.hook';


export default function BindBrands({valueTypeId, brands = [], setErrorApi, getTypes}) {
	const api = useApi();
	const [brandsText, setBrandsText] = useState('');
	const [initialBrandsText, setInitialBrandsText] = useState('');
	const [uploadedOk, setUploadedOk] = useState(false);

	useEffect(() => {
		const val = (brands || []).join('\n');
		setBrandsText(val);
		setInitialBrandsText(val);
	}, [valueTypeId, brands]);

	const showSuccess = () => {
		setUploadedOk(true);
		setTimeout(() => setUploadedOk(false), 1500);
	};

	const handleBind = async () => {
		const brandsList = brandsText.split('\n').filter(b => b.trim());
		try {
			await api.patch(`${getAllMaterialTypesUrl}${valueTypeId}`, {brands: brandsList});
			setInitialBrandsText(brandsText);
			getTypes();
			showSuccess();
		} catch (e) {
			setErrorApi(
				e.response?.data?.detail || e.response?.data?.message || 'Неизвестная ошибка'
			);
		}
	};

	const brandsChanged = brandsText !== initialBrandsText;

	return (
		<div className={styles.container}>
			<label className={styles.label}>Бренды (каждый с новой строки):</label>
			<textarea
				className={styles.textarea}
				value={brandsText}
				onChange={e => setBrandsText(e.target.value)}
				placeholder="Введите бренды, каждый с новой строки"
			/>
			<div className={styles.bind_button_box}>
				<Button
					className={`${styles.bind_button} ${uploadedOk ? styles.uploadedOkBtn : ''}`}
					onClick={handleBind}
					disabled={!brandsChanged && !uploadedOk}
				>
					{uploadedOk ? '✓ Привязано' : 'Привязать'}
				</Button>
			</div>
		</div>
	);
}
